module.exports = __webpack_public_path__ + "media/src/images/icons/flags/peru-c018f488dcf60fef403e4b14b89af5fe.svg";